<template>
    <div class="header">
        <div class="logo" ref="id1">
            <div class="logo-content">
                <img alt="" src="https://gecacademy.oss-cn-beijing.aliyuncs.com/ote/oteimg/Logo1.png" />
            </div>
            <div class="logo-content logo-content1">
                <div class="lang-switch" @click="toggleLanguage">
                    <span :class="{ active: currentLocale === 'zh-CN' }">中</span>
                    <span class="divider">/</span>
                    <span :class="{ active: currentLocale !== 'zh-CN' }">英</span>
                </div>
                <img
                    src="https://gecacademy.oss-cn-beijing.aliyuncs.com/ote/logo/transparent.png"
                    alt=""
                />
               
            </div>
            <div class="mobileNav-box">
                <div class="lang-switch" @click="toggleLanguage">
                    <span :class="{ active: currentLocale === 'zh-CN' }">中</span>
                    <span class="divider">/</span>
                    <span :class="{ active: currentLocale !== 'zh-CN' }">英</span>
                </div>
                <div class="logo-content">
                    <img
                        src="https://gecacademy.oss-cn-beijing.aliyuncs.com/ote/logo/transparent.png"
                        alt=""
                    />
                </div>
                
            </div>
            <div id="mobileNav" v-if="mobileNav">
                <transition name="fade" appear="true">
                    <ul>
                        <li
                            v-for="(item, index) in navShowList"
                            :key="index"
                            @click="navClick(item, 1)"
                        >
                            <a
                                :class="
                                    item.router === activeRouter
                                        ? 'mobileNavactive'
                                        : ''
                                "
                                >{{ item.text }}</a
                            >
                        </li>
                    </ul>
                </transition>
            </div>
        </div>
        <div class="navbox">
            <div class="routerbox">
                <div id="mobileNavToggle">
                    <input
                        type="checkbox"
                        id="checkbox3"
                        v-model="isMobileNavOpen"
                        class="checkbox3 visuallyHidden"
                        @click="mobileNav = !mobileNav"
                    />
                    <label for="checkbox3">
                        <div class="hamburger hamburger3">
                            <img src="https://gecacademy.oss-cn-beijing.aliyuncs.com/ote/oteimg/菜单.png" alt="" />
                        </div>
                    </label>
                </div>
                <div class="nav-links">
                    <div
                        v-for="item in navShowList"
                        @click="navClick(item, 0)"
                        :key="item.id"
                        class="nav-link"
                    >
                        <a
                            :class="
                                item.router === activeRouter ? 'active' : ''
                            "
                            >{{
                                currentLocale === "zh-CN"
                                    ? item.text
                                    : item.textEn
                            }}</a
                        >
                    </div>
                </div>
                <div class="auth-section">
                    <el-badge
                        v-if="isLoggedIn"
                        :value="noReadNum.length"
                        :max="99"
                        :hidden="noReadNum.length < 1"
                        style="margin-right: 10px"
                    >
                        <i
                            class="el-icon-bell"
                            style="
                                font-size: 28px;
                                color: #000;
                                font-weight: 500;
                            "
                            @click="toggleMessageList"
                        ></i>
                    </el-badge>
                    <el-popconfirm
                        :title="$t('headerFoot.logoutTip')"
                        @confirm="handleConfirm"
                        @cancel="handleCancel"
                        :confirm-button-text="$t('modal.logout')"
                        :cancel-button-text="$t('modal.cancel')"
                        icon="el-icon-right"
                        confirm-button-type="text"
                    >
                        <div slot="reference">
                            <div class="avatar" v-if="isLoggedIn">
                                <span class="sp">
                                    <img
                                        :src="userInfo.userInfo.info.nickUrl"
                                        alt=""
                                        v-if="userInfo.userInfo && userInfo.userInfo.info.nickUrl"
                                    />
                                    <img
                                        src="https://gecacademy.oss-cn-beijing.aliyuncs.com/ote/oteimg/头像.png"
                                        alt=""
                                        v-else
                                    />
                                </span>
                                <span class="sp1">
                                    {{
                                        userInfo.userInfo
                                            ? userInfo.userInfo.info.nickName
                                            : ''
                                    }}
                                </span>
                            </div>
                        </div>
                    </el-popconfirm>

                    <!-- 消息弹出列表 -->
                    <div
                        class="message-popup-box"
                        @click="showMessageList = !showMessageList"
                        v-show="showMessageList && isLoggedIn"
                    >
                        <div class="message-popup" @click.stop="" :style="currentLocale === 'en' ? { width: '460px' } : {}">
                             <div
                                class="delete-icon el-icon-close"
                                @click="showMessageList = !showMessageList"
                            ></div>
                            <div class="message-header">
                                <h3>{{ $t("headerFoot.messageinfo") }}</h3>
                                <button
                                    class="mark-all-read"
                                    @click.stop="markAllAsRead"
                                >
                                    <img src="https://gecacademy.oss-cn-beijing.aliyuncs.com/ote/oteimg/已读.png" />
                                    {{ $t("headerFoot.allread") }}
                                </button>
                            </div>

                            <div class="message-list">
                                <div
                                    v-for="(message, index) in messages"
                                    :key="index"
                                    :class="[
                                        'message-item',
                                        { unread: !message.isRead },
                                    ]"
                                    @click.stop="markAsRead(message, index)"
                                >
                                    <el-badge
                                        is-dot
                                        class="item"
                                        :hidden="message.isRead"
                                    >
                                        <p class="el-icon-message" v-if="!message.isRead"></p>
                                        <p class="el-icon-folder-opened" v-else></p>
                                    </el-badge>

                                    <div class="message-content">
                                        <!-- <div class="message-title" v-html="message.message">
                                    </div> -->
                                        <div
                                            class="message-body"
                                            v-html='currentLocale === "zh-CN"?message.message:message.messageEn'
                                        ></div>
                                        <div class="message-meta">
                                            <span class="time">{{
                                                getTime(message.updatedAt)
                                            }}</span>
                                            <span
                                                v-if="message.location"
                                                class="location"
                                                >{{ message.location }}</span
                                            >
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <button
                        @click="showLogin = true"
                        class="auth-btn"
                        v-if="!isLoggedIn"
                    >
                        {{ $t("headerFoot.login") }}
                    </button>
                </div>
            </div>
        </div>
         <transition name="slide">
            <LoginPage
                :showPage="showLogin"
                @close="showLogin = false"
                @closeLogin="showLogin=!showLogin" 
            ></LoginPage>
         </transition>
        <Modal
            :showModal="showModal"
            :show-default-content="false"
            :show-default-tips="false"
            :show-cancel="false"
            :show-delete-icon="true"
            show-size="small"
            @confirm="lgoutConfirm"
            @cancel="lgoutHandleCancel"
        >
            <template #content>
                <div class="modal_content">
                    <el-result icon="warning" class="result-image">
                        <template slot="extra">
                            <p class="text">{{ $t("headerFoot.logout") }}</p>
                            <p class="text1">
                                {{ $t("headerFoot.logoutTip") }}
                            </p>
                        </template>
                    </el-result>
                </div>
            </template>
            <template #footer> </template>
        </Modal>
    </div>
</template>

<script>
import Vue from "vue";
import LoginPage from "@/components/LoginPage.vue";
import {
    getUserMessageInfo,
    frontUserMessage,
    frontUserMessageBatch,
    getPdfRescource
} from "@/plugins/api";
import { formatDateTime } from "@/utils/date";

export default Vue.extend({
    name: "header",
    components: { LoginPage },
    data() {
        return {
            navList: [
                { id: 1, text: "首页", textEn: "Home", router: "/home" },
                // { id: 2, text: "考试报名", router: "/registration" },
                {
                    id: 3,
                    text: "考试订单",
                    textEn: "Test Orders",
                    router: "/order",
                },
                {
                    id: 4,
                    text: "常见问题",
                    textEn: "FAQs",
                    router: "/exam",
                },
                {
                    id: 5,
                    text: "成绩申诉/复议",
                    textEn: "Results Appeal / Review",
                    router: "/appealReconsiderationList",
                },
            ],
            activeIndex: 1,
            mobileNav: false,
            isMobileNavOpen: false,
            btnshow: false,
            mobileShow: false,
            showLogin: false,
            showMessageList: false,
            messages: [],
            noReadNum: 0,
            userInfo: {},
            activeRouter: null,
            showModal: false,
            navShowList: [],
            currentLocale: "zh-CN",
            isLoggedIn: false,
            pdfurl: ''
        };
    },
    watch: {
        "$store.state": {
            handler() {
                this.userInfo = this.$store.state.auth;
                this.isLoggedIn = window.localStorage.getItem("phone");
                if (!this.isLoggedIn) {
                    const list = [...this.navList];
                    this.navShowList = list.filter((item) => {
                        return item.id !== 2 && item.id !== 3 && item.id !== 5;
                    });
                } else {
                    this.navShowList = this.navList;
                }
            },
            deep: true, // 启用深度监听
        },
        "$i18n.locale": {
            handler(newVal) {
                this.currentLocale = newVal || "zh-CN";
            },
        },
        showMessageList: {
            handler(newVal) {
                if (newVal) {
                    document.body.style.overflow = "hidden";
                } else {
                    document.body.style.overflow = "unset";
                }
            },
        }
    },
    async created() {
        this.isLoggedIn = window.localStorage.getItem("phone");
        if (!this.isLoggedIn) {
            const list = [...this.navList];
            this.navShowList = list.filter((item) => {
                return item.id !== 2 && item.id !== 3;
            });
        } else {
            this.navShowList = this.navList;
            getUserMessageInfo().then((res) => {
                this.messages = res;
                const list = [...res];
                this.noReadNum = list.filter((item) => !item.isRead);
            });
        }
        const data = await getPdfRescource({type: 4})
        this.pdfurl = data && data.rows ? data.rows[0].url : null
    },
    mounted() {
        this.$store.dispatch("auth/getUserInfo");
        this.activeRouter = this.$route.path;
        // getUserMessageInfo().then((res) => {
        //     this.messages = res;
        //     const list = [...res];
        //     this.noReadNum = list.filter((item) => !item.isRead);
        // });
    },
    methods: {
        toggleLanguage() {
            // 注意：如果项目 i18n 里英文的 key 是 "en" 而不是 "en-US"，
            // 把下面的 "en-US" 换成 "en" 即可
            const targetLocale =
                this.$i18n.locale === "zh-CN" ? "en" : "zh-CN";
            this.$i18n.locale = targetLocale;
            window.localStorage.setItem("locale", targetLocale);
        },
        navClick(item, type) {
            if (item.id === 4) {
                this.activeIndex = 1;
                window.open(this.pdfurl, "_blank");
            } else {
                this.activeRouter = item.router;
                if (type) {
                    this.isMobileNavOpen = false;
                    this.mobileNav = !this.mobileNav;
                }
                this.$router.push(item.router);
            }
        },
        closeLogin() {
            this.showLogin = false;
        },
        toggleMessageList() {
            getUserMessageInfo().then((res) => {
                this.messages = res;
                const list = [...res];
                this.noReadNum = list.filter((item) => !item.isRead);
            });
            this.showMessageList = !this.showMessageList;
        },

        closeMessageList() {
            this.showMessageList = false;
        },

        async markAsRead(message, index) {
            await frontUserMessage(message.id);
            this.$set(message, "isRead", true);
            this.messages[index].isRead = true;
            this.noReadNum = this.messages.filter((item) => !item.isRead);
        },

        async markAllAsRead() {
            // let idList = this.messages
            //     .filter((item) => item.isRead)
            //     .map((item) => item.id);
            await frontUserMessageBatch({ ids: null });
            this.messages.forEach((item) => this.$set(item, "isRead", true));
            this.noReadNum = this.messages.filter((item) => !item.isRead);
        },
        handleConfirm() {
            this.showModal = true;
        },
        handleCancel() {},
        lgoutConfirm() {
            const loading = this.$loading({
                lock: true,
                text: "Loading",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            this.$store.dispatch("auth/logout").then(() => {
                this.showModal = false;
                this.$router.push("/home");
            });
            loading.close();
        },
        lgoutHandleCancel() {
            this.showModal = false;
        },
        getTime(time) {
            return formatDateTime(time);
        },
    },
});
</script>
<style lang="stylus" scoped>
header {
    .lang-switch {
        display: flex;
        flex-flow: row;
        align-items: center;
        margin-right: 10px;
        color: #fff;
        font-size: 12px;
        font-weight: 500;
        cursor: pointer;
        user-select: none;

        span {
            padding: 0 2px;
            transition: color 0.3s ease;
        }

        .active {
            font-weight: 700;
            font-size: 16px;
        }

        .divider {
            color: rgba(255, 255, 255, 0.6);
        }
    }
    .logo {
        max-width: 1200px;
        height: 60px;
        background: #011e41;
        display: flex;
        flex-flow: row;
        align-items: center;
        justify-content: space-between;
        margin: 0 auto;

        .logo-content {
            display: flex;
            flex-flow: row;
            align-items: center;
            justify-content: space-between;
        }

        .logo-content img {
            height: 36px;
        }
    }

    .mobileNav-box {
        display: none;
    }

    .main-nav {
        display: flex;
        list-style: none;
        justify-content: center;
        flex-wrap: wrap;

        a {
            padding: 10px;
            text-decoration: none;
            color: #fff;
            font-weight: 500;
            border-radius: 8px;
            transition: all 0.3s ease;
            position: relative;
        }

        a.active {
            color: white;
            font-size: 18px;
        }

        a::after {
            content: '';
            position: absolute;
            bottom: 0;
            left: 50%;
            width: 0;
            height: 3px;
            background: #b5b9bb;
            transition: all 0.3s ease;
            transform: translateX(-50%);
        }
    }

    .mobileNavactive {
        color: white;
        font-size: 18px;
    }

    .main-nav a.active::after {
        width: 40%;
        background: #fff;
    }

    #mobileNavToggle, .mobileProfileIcon, #mobileLangs, .mobile-service-info, .service-body.no-agenda .service-info.mobile-service-info, .mobileNav-box {
        display: none;
    }

    .navbox {
        width: 100%;
        background-color: white;
        background: #D5DAE0;
    }

    .routerbox {
        display: flex;
        justify-content: space-between;
        align-items: center;
        max-width: 1200px;
        margin: 0 auto;

        .nav-links {
            display: flex;
            padding: 10px 0;
        }

        .nav-link {
            text-decoration: none;
            color: #011E41;
            font-weight: 500;
            padding: 0.5rem 1rem;

            a {
                padding: 10px;
                text-decoration: none;
                color: #011E41;
                font-weight: 500;
                border-radius: 8px;
                position: relative;
            }

            a.active {
                color: #011E41;
                font-size: 18px;
                font-weight: 700;
            }

            a::after {
                content: '';
                position: absolute;
                bottom: 0;
                left: 50%;
                width: 0;
                height: 3px;
                background: #b5b9bb;
                transition: all 0.3s ease;
                transform: translateX(-50%);
            }
        }

        a.active::after {
            width: 40%;
            background: #000;
        }

        .auth-section {
            position: relative;
            display: flex;
            flex-flow: row;
            align-items: center;
        }

        .auth-section:hover {
            // transform: scale(1.01);
        }

        .auth-btn {
            padding: 0.5rem 0.8rem;
            background: #0043E0;
            color: white;
            border: none;
            border-radius: 4px;
            cursor: pointer;
            font-size: 0.9rem;
            transition: background-color 0.3s;
        }

        .auth-btn:hover {
            border-bottom: 2px solid transparent;
        }

        .login-dropdown {
            position: absolute;
            top: 100%;
            right: 0;
            background: white;
            padding: 1rem;
            border-radius: 4px;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
            margin-top: 0.5rem;
            min-width: 250px;
            z-index: 1000;
        }

        .login-dropdown input {
            width: 100%;
            padding: 0.5rem;
            margin-bottom: 0.5rem;
            border: 1px solid #ddd;
            border-radius: 4px;
        }

        .login-submit, .register-btn {
            width: 100%;
            padding: 0.5rem;
            margin-bottom: 0.5rem;
            border: none;
            border-radius: 4px;
            cursor: pointer;
        }

        .login-submit {
            background-color: #4CAF50;
            color: white;
        }

        .register-btn {
            background-color: #f5f5f5;
            color: #333;
        }

        .login-dropdown {
            position: absolute;
            top: 100%;
            right: 0;
            background: white;
            padding: 1rem;
            border-radius: 4px;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
            margin-top: 0.5rem;
            min-width: 250px;
            z-index: 1000;
        }

        .login-dropdown input {
            width: 100%;
            padding: 0.5rem;
            margin-bottom: 0.5rem;
            border: 1px solid #ddd;
            border-radius: 4px;
        }

        .login-submit, .register-btn {
            width: 100%;
            padding: 0.5rem;
            margin-bottom: 0.5rem;
            border: none;
            border-radius: 4px;
            cursor: pointer;
        }

        .login-submit {
            background-color: #4CAF50;
            color: white;
        }
    }

    .avatar {
        // width: 32px;
        // height: 32px;
        // background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        // border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;

        // color: white;
        // font-weight: bold;
        // font-size: 16px;
        // box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
        // transition: transform 0.2s ease;
        .sp {
            width: 38px;
            height: 38px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            color: white;
            font-weight: bold;
            font-size: 16px;
            transition: transform 0.2s ease;

            img {
                width: 100%;
                height: 100%;
                border-radius: 50%;
            }
        }

        .sp1 {
            font-size: 16px;
            color: #000;
            margin-left: 8px;
        }
    }

    .avatar:hover {
        // transform: scale(1.05);
    }

    .badge {
        position: absolute;
        top: -5px;
        right: -5px;
        background-color: #ff4757;
        color: white;
        font-size: 12px;
        font-weight: bold;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        animation: pulse 2s infinite;
    }

    @keyframes pulse {
        0% {
            box-shadow: 0 0 0 0 rgba(255, 71, 87, 0.7);
        }

        70% {
            box-shadow: 0 0 0 6px rgba(255, 71, 87, 0);
        }

        100% {
            box-shadow: 0 0 0 0 rgba(255, 71, 87, 0);
        }
    }

    .overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: transparent;
        z-index: 998;
    }

    .message-popup-box {
        position: fixed;
        width: 100vw;
        height: 100vh;
        z-index: 999;
        left: 0;
        top: 0;
        background-color: rgba(0, 0, 0, 0.4);
    }

    .message-popup {
        position: absolute;
        top: 120px;
        right: 12vw;
        width: 420px;
        height: 620px;
        background: white;
        border-radius: 12px;
        box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1), 0 20px 20px rgba(0, 0, 0, 0.05);
        z-index: 999;
        animation: slideDown 0.3s ease;
        .delete-icon {
            position: absolute;
            top: 6px;
            right: 6px;
            z-index: 2;
            color: #000;
            font-size: 1.5em;
        }
    }

    @keyframes slideDown {
        from {
            opacity: 0;
            transform: translateY(-20px);
        }

        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    .message-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 16px 20px;
        color: #011E41;
        position: relative;
    }

    .message-header::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 2px;
        background: linear-gradient(90deg, #50B9AA 0%, #E2CB24 100%);
    }

    .message-header h3 {
        margin: 0;
        font-size: 18px;
        font-weight: 600;
    }

    .mark-all-read {
        background: rgba(255, 255, 255, 0.2);
        border: none;
        color: #0043E0;
        padding: 6px 12px;
        border-radius: 20px;
        font-size: 13px;
        cursor: pointer;
        transition: background 0.3s ease;
        display: flex;
        flex-flow: row;
        align-items: center;

        img {
            width: 14px;
            margin-right: 6px;
        }
    }

    .mark-all-read:hover {
        background: rgba(255, 255, 255, 0.3);
    }

    .message-list {
        max-height: 540px;
        overflow-y: auto;
        padding: 1.2vw 0.1vw 3.5vw 0.1vw;
        padding-bottom: 2vh;
    }

    .message-item {
        padding: 10px 12px;
        border-bottom: 1px solid #f0f0f0;
        cursor: pointer;
        transition: background 0.2s ease;
        position: relative;
        display: flex;
        flex-flow: row;
        // align-items: center;
        justify-content: space-between;

        .item {
            margin-right: 12px;
            margin-top: 10px;
            font-size: 26px;

            >>>.el-badge__content {
                width: 12px !important;
                height: 12px !important;
                min-width: 12px;
            }

            /* 如果需要调整位置 */
            >>>.el-badge__content {
                transform: translate(50%, -50%) scale(1.2); /* 调整缩放 */
            }

            >p {
                width: 42px;
                height: 42px;
                border-radius: 50%;
                background: #0043E0;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 26px;
            }
        }

        .message-content {
            flex: 1;
            position: relative;
            background: #FAFCFF;
            border-radius: 10px;
            border: 1px solid #78A0D0;
            padding: 10px 20px;

            .message-title {
                font-weight: 600;
                color: #011E41;
                margin-bottom: 6px;
                font-size: 18px;
                text-align: left;
            }

            .message-body {
                color: #011E41;
                font-size: 14px;
                line-height: 1.5;
                margin-bottom: 8px;
                word-wrap: break-word;
                text-align: left;
                // padding-right: 10px;
            }

            .message-meta {
                position: absolute;
                top: 10px;
                right: 10px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                font-size: 14px;
                color: #52739B;
            }
        }
    }

    .message-item:hover {
        background: #f9f9f9;
    }

    .message-item.unread {
        // background: #f8f9ff;
    }

    .time {
        font-size: 14px;
    }

    .location {
        background: #f0f0f0;
        padding: 2px 8px;
        border-radius: 12px;
        font-size: 11px;
    }

    /* 滚动条样式 */
    .message-list::-webkit-scrollbar {
        width: 6px;
    }

    .message-list::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 3px;
    }

    .message-list::-webkit-scrollbar-thumb {
        background: #c1c1c1;
        border-radius: 3px;
    }

    .message-list::-webkit-scrollbar-thumb:hover {
        background: #a8a8a8;
    }

    .modal_content {
        display: flex;
        flex-flow: column;
        align-items: center;
        justify-content: center;

        .text {
            font-weight: bold;
            font-size: 20px;
            color: #000000;
            margin-top: 10px;
        }

        .text1 {
            font-size: 16px;
            color: #000000;
            margin-top: 8px;
        }
    }
}

/* 手机类 */
@media (max-width: 640px) {
    header {
        .logo {
            max-width: 100%;
            max-height: 10vh;
            position: relative;
        }

        .logo-content {
            /* margin-right: 20vw; */
            img {
                // height: 4.8vh;
                width: 26vw;
                height: auto !important;
                margin-left: 16px;
            }
        }


        .main-nav {
            display: none;
        }

        .logo-content1 {
            display: none !important;
        }

        .mobileNav-box {
            display: block;
            display: flex;
            flex-flow: row;
            align-items: center;
             .logo-content img {
                width: 32vw;
            }
            padding-right: 16px;
        }

        .routerbox {
            padding: 2.6vw 3vw 2.6vw 0;

            .nav-links {
                display: none;
            }

            .auth-btn {
                font-size: 3vw;
                padding: 1.5vw 1.8vw;
            }
        }

        .auth-section {
            position: relative;
            >>>.el-badge {
                margin-right: 2.8vw !important;

                .el-icon-bell {
                    font-size: 6.8vw !important;
                }
            }
        }

        .avatar {
            .sp {
                width: 6.8vw;
                height: 6.8vw;
            }

            .sp1 {
                font-size: 4vw;
                margin-left: 1vw;
            }
        }

        #mobileNavToggle {
            display: block;
            // position: absolute;
            top: 0;
            right: 0;
            z-index: 99;
            width: 12vw;
            height: 100%;
            line-height: 100%;
            display: flex;
            flex-flow: row;
            align-items: center;
            justify-content: center;

            /* margin:0  2vw; */
            .visuallyHidden {
                position: absolute;
                overflow: hidden;
                clip: rect(0 0 0 0);
                height: 1px;
                width: 1px;
                margin: -1px;
                padding: 0;
                border: 0;
            }

            label {
                // margin-bottom: 3vw;
            }

            .hamburger {
                margin: 0 auto;
                width: 6vw;

                img {
                    width: 100%;
                    height: 100%;
                }
            }
        }

        #mobileNav {
            background: #011e41;
            top: 28vw;
            position: absolute;
            z-index: 99;
            width: 40vw;
            height: 100vh;
            opacity: 0.9;
        }

        #mobileNav ul {
            padding: 0 0;
            padding-top: 4.35vw;
            padding-bottom: 4.35vw;
            text-align: center;
        }

        #mobileNav ul li {
            list-style-type: none;
        }

        #mobileNav ul li a {
            // color: #001321;
            color: #fff;
            font-size: 4.615vw;
            text-align: center;
            font-weight: 500;
            padding-top: 2.8vw;
            padding-bottom: 2vw;
            display: block;
            text-decoration: none;
        }

        #mobileNav ul li a.mobileNavactive {
            color: #0043E0;
        }

        .message-popup-box {
            position: fixed;
            width: 100vw;
            height: 100vh;
            z-index: 999;
            left: 0;
            top: 0;
            background-color: rgba(0, 0, 0, 0.2);
        }

        .navbox .message-popup {
            position: fixed;
            // top: 28vw;
            // right: 10px;
            width: 80vw;
            max-width: 100%;
            left: 0;
            right: 0;
            top: 30vh;
            height: 80vh;
            z-index: 999;
            width: 100vw;

            .message-header {
                padding: 2.6vw 4vw;

                h3 {
                    font-size: 4.6vw;
                }

                .mark-all-read {
                    font-size: 3.8vw;

                    img {
                        width: 4vw;
                        margin-right: 1vw;
                    }
                }
            }

            .message-list {
                padding-bottom: 12vh;

                .message-item {
                    .item {
                        > p {
                            font-size: 5vw;
                            width: 8.8vw;
                            height: 8.8vw;
                        }
                    }
                }

                .message-content {
                    padding: 2.6vw 4vw;

                    .message-title {
                        font-size: 3.6vw;
                    }

                    .message-body, .message-meta {
                        font-size: 3vw;

                        .time {
                            font-size: 3.2vw;
                        }
                    }
                }
            }
        }
    }
}
</style>
